import PropTypes from "prop-types";
import React from "react";
import SectionHead from "shared/components/layout/heads/SectionHead";
import Icon from "shared/components/utils/Icon";
import {
    StyledModal,
    CustomStyles,
    StyledHeader,
    StyledIcon,
    StyledForm,
    ReactModalGlobalStyles,
} from "shared/components/feedback/modals/MasterModal.styles";

const MasterModal = ({
    title,
    description,
    stickyAction,
    width,
    show,
    onRequestClose,
    children,
    zIndex,
    showFooter,
}) => {
    function handleClose() {
        if (onRequestClose) {
            onRequestClose();
        }
    }

    const isClosable = onRequestClose !== undefined;

    const titleHeader = (
        <StyledHeader spacing="Zero">
            <SectionHead title={title} description={description} />
            {isClosable && (
                <StyledIcon
                    type="button"
                    onClick={handleClose}
                    aria-label="Close Modal"
                >
                    <Icon name="close" color="Gray_2" size={24} />
                </StyledIcon>
            )}
        </StyledHeader>
    );

    return (
        <>
        <ReactModalGlobalStyles />
        <StyledModal
            isOpen={show}
            onRequestClose={isClosable ? handleClose : undefined}
            contentLabel="Modal"
            style={CustomStyles}
            width={width}
            scrollable={true}
            stickyAction={stickyAction}
            onAfterClose={() => {
                document.activeElement.blur();
            }}
            zIndex={zIndex}
            showFooter={showFooter}
            shouldCloseOnOverlayClick={isClosable}
            shouldCloseOnEsc={isClosable}
        >
            {title && title.length > 0 ? titleHeader : null}
            <StyledForm>{children}</StyledForm>
        </StyledModal>
        </>
    );
};

MasterModal.defaultProps = {
    show: true,
    onRequestClose: null,
    title: "",
    description: null,
    stickyAction: false,
    width: 480,
    zIndex: 1001,
    showFooter: true,
};

MasterModal.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string,
    description: PropTypes.string,
    stickyAction: PropTypes.bool,
    width: PropTypes.number,
    zIndex: PropTypes.number,
    showFooter: PropTypes.bool,
    onRequestClose: PropTypes.func,
    children: PropTypes.node,
};

export default MasterModal;
